export const replaceSpecialChars = (str) => {
	return str.toLocaleLowerCase()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.trim()
		.replace(/[^\w\s]/gi, "")
		.replace(/(\s{2,})|(\s)/g, "_")
}